import ReminderToVerifyPhoneNumberModal from './ReminderToVerifyPhoneNumberModal.component';

export default ReminderToVerifyPhoneNumberModal;
